import { render, staticRenderFns } from "./ListTypes.vue?vue&type=template&id=965436ca&"
import script from "./ListTypes.vue?vue&type=script&lang=js&"
export * from "./ListTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('965436ca')) {
      api.createRecord('965436ca', component.options)
    } else {
      api.reload('965436ca', component.options)
    }
    module.hot.accept("./ListTypes.vue?vue&type=template&id=965436ca&", function () {
      api.rerender('965436ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/Types/ListTypes.vue"
export default component.exports